import React from 'react';
import { FaLightbulb, FaCog, FaChartLine } from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <FaLightbulb />,
      title: 'Strategy & Roadmap Development',
      description: 'We conduct readiness assessments, identify high-impact use cases, define governance models, and shape phased implementation plans.'
    },
    {
      icon: <FaCog />,
      title: 'Process Automation & Optimization',
      description: 'Automate repetitive tasks using advanced technologies, including automated customer service and document processing solutions.'
    },
    {
      icon: <FaChartLine />,
      title: 'Custom Development',
      description: 'Create bespoke solutions that match your business needs. Build scalable platforms that grow with your business.'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2>Services Tailored to Your Needs</h2>
          <p>Our team identifies high-impact opportunities and helps you rethink how you approach challenges and create solutions.</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services; 